import React from 'react';
import { Table } from 'semantic-ui-react';

import { Field } from 'react-final-form';
import { RenderRadio } from 'forms';
import { format } from 'date-fns';
import { SprayEventWeather } from 'services/sprayEvents/types';
import classNames from 'classnames';
import { IncompleteWeatherSprayEvent } from '../../../../types';

interface Props {
    index: number;
    sprayEvent: IncompleteWeatherSprayEvent;
}

export default class CompleteCropSprayEventFormTableWeatherRow extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { index, sprayEvent } = this.props;
        const { key, startDate } = sprayEvent;

        const rowClassname = classNames('complete-spray-event-form-table-row', {
            first: index === 0
        });

        return (
            <Table.Row className={rowClassname}>
                <Table.Cell>
                    <div className="table-cell-inner">
                        {index === 0 &&
                            format(new Date(startDate), 'MMM d yyyy')}
                    </div>
                </Table.Cell>
                <Table.Cell>
                    <div className="table-cell-inner">
                        <span>{sprayEvent.entityName}</span>
                    </div>
                </Table.Cell>
                <Table.Cell className="selectable-table-cell">
                    <div className="table-cell-inner center">
                        <Field
                            id={`${key}.calm`}
                            name={key}
                            component={RenderRadio as any}
                            className="round-checkbox"
                            type="radio"
                            value={SprayEventWeather.CALM}
                            defaultValue={SprayEventWeather.CALM}
                        />
                    </div>
                </Table.Cell>
                <Table.Cell className="selectable-table-cell">
                    <div className="table-cell-inner center">
                        <Field
                            id={`${key}.breezy`}
                            name={key}
                            component={RenderRadio as any}
                            className="round-checkbox"
                            type="radio"
                            value={SprayEventWeather.BREEZY}
                        />
                    </div>
                </Table.Cell>
                <Table.Cell className="selectable-table-cell">
                    <div className="table-cell-inner center">
                        <Field
                            id={`${key}.windy`}
                            name={key}
                            component={RenderRadio as any}
                            className="round-checkbox"
                            type="radio"
                            value={SprayEventWeather.WINDY}
                        />
                    </div>
                </Table.Cell>
                <Table.Cell className="selectable-table-cell">
                    <div className="table-cell-inner center">
                        <Field
                            id={`${key}.dry`}
                            name={key}
                            component={RenderRadio as any}
                            className="round-checkbox"
                            type="radio"
                            value={SprayEventWeather.DRY}
                        />
                    </div>
                </Table.Cell>
                <Table.Cell className="selectable-table-cell">
                    <div className="table-cell-inner center">
                        <Field
                            id={`${key}.showery`}
                            name={key}
                            component={RenderRadio as any}
                            className="round-checkbox"
                            type="radio"
                            value={SprayEventWeather.SHOWERY}
                        />
                    </div>
                </Table.Cell>
                <Table.Cell className="selectable-table-cell">
                    <div className="table-cell-inner center">
                        <Field
                            id={`${key}.rain`}
                            name={key}
                            component={RenderRadio as any}
                            className="round-checkbox"
                            type="radio"
                            value={SprayEventWeather.RAIN}
                        />
                    </div>
                </Table.Cell>
            </Table.Row>
        );
    }
}
